import React from "react";
import classNames from "classnames";
import "./index.scss";

import MapAddressControl from "../MapAddressControl";

const SectionItemMapAddress = ({ item, value, column, onPropChange }) => {
  const handleOnChangeProp = propValue => {
    !column.isReadonly && onPropChange(propValue);
  }

  return (
    <div className={classNames("sectionItemMapAddress")}>
      <MapAddressControl
        item={item}
        value={value}
        searchInfo={item.searchInfo}
        isHideSearch={column.isHideSearch}
        isHidePolygon={column.isHidePolygon}
        onPropChange={handleOnChangeProp}
        isHideFindAddress={column.isHideFindAddress}
        isLocationByPosition={column.isLocationByPosition}
      />
    </div>
  );
}

export default SectionItemMapAddress;
